/**
 *
 * FormCTA
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import { SButton, SDescription, SFindOutMore } from './styles';
import Heading2 from 'components/Heading/H2';
import ThinArrowRight from 'images/svg/arrow-thin-right.svg';
import { FormProvider, useForm } from 'react-hook-form';
import { mediaBreakpointDown } from 'utils/styledCssHelpers';
import { postToSlack } from 'utils/postToSlack';
import Input from 'components/inputs';
import { handleResponesWithToastify } from 'utils/globalHelpers';
import { addToActiveCampaign } from 'utils/addToActiveCampaign';

export const FormCTA = ({
  title,
  titleColor = '#92addc',
  isHeading1,
  description,
  featuresList = [],
  onClick,
  ctaText = 'Submit',
  customCTA = null,
  titleChildren,
  mode,
  acId,
  acMetaOr,
}) => {
  const sendData = () => {};

  const validatedForm = data => {
    const slack_requestData = {
      title: 'New Oasis Living Lead!',
      message: `New lead from Oasis Living 'What’s selling in your area?' 🥳 \nArea searched for: ${data.postcode} \nWho searched: ${data.user_email}`,
    };
    postToSlack('team-mkt-leads', { ...slack_requestData }).then(success => {
      handleResponesWithToastify({
        success: success,
        message: success
          ? 'Thank you for your submission.'
          : 'Form Submission failed, please contact support.',
      });

      if (acId && acMetaOr) {
        addToActiveCampaign(acId, acMetaOr, {
          email: data.user_email,
        });
      }
    });
  };

  const methods = useForm();

  return (
    <div className="mx-3 mx-md-0 text-center text-md-start ps-lg-5 py-5 py-lg-0">
      {titleChildren}
      {title && (
        <Heading2
          padding="0 150px 0 0"
          colour={titleColor}
          isTitle={true}
          text={title}
          className="my-3 mt-md-0"
          $extraStyle={`${mediaBreakpointDown(
            'lg',
            `
              padding-right: 0;
            `,
          )};`}
        />
      )}
      {description && <SDescription mode={mode}>{description}</SDescription>}
      <div className="d-flex justify-content-center justify-content-md-start">
        <FormProvider {...methods}>
          <Input
            size="small"
            placeholder="yourname@email.com"
            type="email"
            name="user_email"
            required
          />
          <Input
            size="small"
            placeholder="Postcode"
            type="alphanumeric"
            name="postcode"
            required
          />
          <SButton
            variant="full"
            onClick={() => methods.handleSubmit(validatedForm)()}
          >
            {ctaText}
          </SButton>
        </FormProvider>
      </div>
      <SFindOutMore>
        <a href="" style={{ color: 'white' }}>
          Find out more <ThinArrowRight />
        </a>
      </SFindOutMore>
    </div>
  );
};

FormCTA.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  featuresList: PropTypes.array,
  ctaText: PropTypes.string,
  isHeading1: PropTypes.bool,
  customCTA: PropTypes.element,
  titleChildren: PropTypes.element,
  titleColor: PropTypes.string,
  mode: PropTypes.string,
  acId: PropTypes.number,
  acMetaOr: PropTypes.string,
};

export default FormCTA;
